import * as React from "react";
import { Grid } from "@mui/material";

import { DynamicField } from "@/components/dynamicField/dynamic-field";

export function Settings({ control, fields, summarySchema }: { control: any; fields: any; summarySchema?: any }) {
	return (
		<Grid container spacing={2}>
			{fields?.map((field: any) => (
        <DynamicField
          control={control}
          gridSize={{ xs: 12, md: 12 }}
          key={field.id}
          type={field.type}
          name={`settings.${field.name}`}
          label={field.label}
          dynamicField={{ ...field, summaryInfo: field.name === 'summarize_prompt' ? summarySchema : undefined }}
          dependsOn={field.dependsOn}
          formName="settings"
        />
			))}
		</Grid>
	);
}
